/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import "../../css/mobile-intro/mobile-intro.css";
import { useNavigate } from "react-router-dom";
import Carousel from "react-bootstrap/Carousel";
import { isMobile } from "react-device-detect";
import LoginConfirmModal from "../../componant/modal/LoginConfirmModal";
import { postCommBannerList } from "../../api/banner";
import { toast } from "wc-toast";

export default function MobildIntro({ priceData }) {
  const isIOS =
    /(iPad|iPhone|iPod|Mac).*AppleWebKit(?!.*Safari)/i.test(
      navigator.userAgent
    ) && !window.MSStream;

  const [isListView, setIsListView] = useState(false);

  const [text, setText] = useState({ buy: "", sell: "" });
  const [opacity, setOpacity] = useState(0);
  const [opacity2, setOpacity2] = useState(0);
  const [opacityLeft, setOpacityLeft] = useState(0);
  const [opacityRight, setOpacityRight] = useState(0);
  const [textColor1, setTextColor1] = useState("#3264ce");
  const [textColor2, setTextColor2] = useState("#F34250");
  const [leftX, setLeftX] = useState("-250px");
  const [rightX, setRightX] = useState("-250px");
  const navigate = useNavigate();
  const servicePhoneNum = "010-4478-8944";

  const [showLoginModal, setShowLoginModal] = useState(false);
  const [bannerList, setBannerList] = useState([]);

  const isBannerValid = (item) => {
    const todayStr = new Date().toISOString().split("T")[0];
    const { start_date, end_date } = item;

    if (start_date && end_date) {
      return todayStr >= start_date && todayStr <= end_date;
    }
    if (start_date && !end_date) {
      return todayStr >= start_date;
    }
    if (!start_date && end_date) {
      return todayStr <= end_date;
    }
    return true;
  };

  const handleBannerApi = async (bannerSeq, targetStr) => {

    try {
      const payload = {
        banner_seq: String(bannerSeq || ""),
        target_str: targetStr,
      };

      const response = await postCommBannerList(payload);
      if (bannerSeq === "ALL" && response?.code === 1000) {
        setBannerList(response?.resultList);
      }
    } catch (err) {
      console.error("배너 처리 실패:", err);
      // toast.error("배너 데이터를 불러오는 중 오류가 발생했습니다.");
    } 
  };

  const handleBannerClick = (item) => {
    if (item?.banner_seq) {
      handleBannerApi(item.banner_seq, "click_cnt");
    }
    if (item?.url) {
      window.open(item.url, "_blank", "noopener,noreferrer");
    }
  };

  useEffect(() => {
    setLeftX("0px");
    setRightX("0px");

    setTimeout(function () {
      setOpacity(1);
      setOpacity2(1);
    }, 300);

    setTimeout(function () {
      setText({ buy: "삽니다", sell: "팝니다" });
    }, 1500);

    handleBannerApi("ALL", "view_cnt");
  }, []);

  const goToPhonCallApp = () => {
    const digitsOnly = servicePhoneNum.replace(/-/g, "");
    if (!isMobile) {
      alert("전화는 모바일에서만 가능합니다.");
      return;
    }
    if (
      typeof TOPTOP_APP === "object" &&
      typeof TOPTOP_APP.makePhoneCall === "function"
    ) {
      TOPTOP_APP.makePhoneCall(digitsOnly);
    } else if (isIOS) {
      webkit.messageHandlers.makePhoneCall.postMessage(digitsOnly);
    } else {
      window.location.href = `tel:${digitsOnly}`;
    }
  };

  const handleDailyCheckClick = () => {
    const accessToken = localStorage.getItem("access_token");
    if (accessToken) {
      navigate("/inspection");
    } else {
      setShowLoginModal(true);
    }
  };


  return (
    <div className="mobile-intro-wrapper">
      <div className="header">
        <div className="header-text">쉽고 빠른 화물 넘버 거래</div>
        <div className="header-img">
          <img
            src={process.env.PUBLIC_URL + `/img/mobile-top-logo.png`}
            alt="TOPTOP Logo"
          />
        </div>
      </div>
      <div className="section">
        <div className="price-box">거래 시세</div>
        <Carousel interval={3000} prevIcon={null} nextIcon={null}>
          {priceData?.map((item, index) => {
            if (
              item?.car_weight_cd === 2303 ||
              item?.car_weight_cd === 2304
            )
              return null;
            return (
              <Carousel.Item key={index}>
                <div className="d-flex">
                  <div className="gray-box">
                    {item?.deal_category_cd === 2101 &&
                      item?.car_weight_cd === 2301 &&
                      "개인용달"}
                    {item?.deal_category_cd === 2101 &&
                      item?.car_weight_cd === 2302 &&
                      "개인개별"}
                    {item?.deal_category_cd === 2104 && "주선면허"}
                  </div>
                  <div className="d-flex align-items-center">
                    <span
                      className={`${(item?.deal_category_cd === 2101 &&
                        item?.car_weight_cd === 2301 &&
                        "lbl-orange") ||
                        (item?.deal_category_cd === 2101 &&
                          item?.car_weight_cd === 2302 &&
                          "lbl-green") ||
                        (item?.deal_category_cd === 2104 && "lbl-purple")
                        } amount`}
                    >
                      {item?.avg_price
                        ?.toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    </span>
                    <span className="price-unit">만원</span>
                  </div>
                </div>
              </Carousel.Item>
            );
          })}
        </Carousel>
      </div>

      <LoginConfirmModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
      />

      <div className="mobile-intro-img-wrapper">
        <img
          src={process.env.PUBLIC_URL + `/img/mobile-intro-buy.png`}
          alt=""
          className="mobile-intro-img-buy"
          style={{ "--left-x": leftX, "--opacity": opacity }}
        />
        <img
          src={process.env.PUBLIC_URL + `/img/mobile-intro-buy_click.png`}
          alt=""
          className="mobile-intro-img-buy-3"
          style={{ "--opacity": opacityLeft }}
          onClick={() => {
            setOpacityLeft(1);
            setTimeout(function () {
              navigate("/buying");
            }, 500);
          }}
        />
        <img
          src={process.env.PUBLIC_URL + `/img/mobile-intro-sell.png`}
          alt=""
          className="mobile-intro-img-sell"
          style={{ "--right-x": rightX, "--opacity": opacity }}
        />
        <img
          src={process.env.PUBLIC_URL + `/img/mobile-intro-sell_click.png`}
          alt=""
          className="mobile-intro-img-sell-3"
          style={{ "--opacity": opacityRight }}
          onClick={() => {
            setOpacityRight(1);
            setTimeout(function () {
              navigate("/selling");
            }, 500);
          }}
        />
      </div>

      <div className="footer">
        <div className="mb-2" style={{ padding: "0 10px" }}>
          <button
            type="button"
            onClick={handleDailyCheckClick}
            className="w-100 d-flex justify-content-center align-items-center"
            style={{
              background: "#1B7F4B",
              color: "#fff",
              border: "none",
              borderRadius: "12px",
              height: "56px",
              fontSize: "18px",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            운수종사자 일상점검표
          </button>
        </div>

        <div style={{ padding: "0 10px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              marginBottom: "4px",
            }}
          >
            <button
              type="button"
              onClick={() => navigate("/banner-list", { state: { bannerList } })}
              style={{
                background: "none",
                border: "none",
                fontSize: "12px",
                fontWeight : "bold",
                color: "#666",
                cursor: "pointer",
                padding: "0",
              }}
            >
              전체보기 &gt;
            </button>
          </div>

          {/* 하단 배너 캐러셀 */}
          {bannerList && bannerList.length > 0 && (
            <Carousel
              interval={bannerList.length > 1 ? 3000 : null}
              controls={false}
              indicators={bannerList.length > 1}
            >
              {bannerList.map((item, index) => (
                <Carousel.Item key={item.banner_seq}>
                  <img
                    src={item.banner_img}
                    alt={item.banner_title}
                    style={{
                      width: "100%",
                      height : "80px",
                      borderRadius: "8px",
                      cursor: "pointer",
                      display: "block",
                    }}
                    onClick={() => handleBannerClick(item)}
                  />
                </Carousel.Item>
              ))}
            </Carousel>
          )}
        </div>

        <div className="phone-box">
          <div className="phone-inner">
            <div className="phone-text">
              <div>TOPTOP 고객센터 (평일 09:00~18:00)</div>
              <div
                className="phone"
                style={{
                  cursor: isMobile ? "pointer" : "default",
                }}
                onClick={() => {
                  if (isMobile) {
                    goToPhonCallApp();
                  }
                }}
              >
                {servicePhoneNum}
              </div>
            </div>
            <img
              src={"/img/icon_phone.svg"}
              alt=""
              style={{ width: "80px", height: "80px" }}
              onClick={() => {
                if (isMobile) {
                  goToPhonCallApp();
                }
              }}
            />
          </div>
        </div>
        <div className="copy-right">
          Copyright ⓒ Assembrix Co.,Ltd. All rights reserved.
        </div>
      </div>
    </div>
  );
}